import React, { useEffect } from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/MessageBox";

/**
 * O aviso da casa. Sucesso, erro e recusa.
 *
 * Duas coisas mudaram aqui, e as duas eram silêncio:
 *
 * 1. `messageType || "success"` — com o tipo declarado como `"" | null`, o
 *    TypeScript estreitava a expressão para o literal "success" e TODO aviso
 *    saía verde, inclusive "não salvei". O tipo agora é o que o código guarda
 *    de verdade (ver `MessageSlice`), e o tom escolhido é o tom pintado.
 *
 * 2. Ele nunca esteve montado na área privada — só em LoginPage e RegisterPage.
 *    Todo `setMessageZustand` da Configuração era gravado na store e nunca
 *    pintado. Agora ele vive no MainLayout.
 *
 * O sumiço automático existe porque a mensagem era PERSISTIDA na store: sem
 * ele, um aviso ficava na tela até alguém clicar no X e REAPARECIA na sessão
 * seguinte, no /login. (A persistência também saiu — ver o `partialize` em
 * store/index.ts.) O tom de erro fica mais tempo: quem errou precisa ler.
 */
const SEGUNDOS_NA_TELA: Record<string, number> = {
  success: 6,
  warning: 12,
  error: 15,
};

const MessageBox: React.FC = () => {
  const message = useCombinedStore((state) => state.messageZustand);
  const messageType = useCombinedStore((state) => state.messageTypeZustand);
  const clearMessage = useCombinedStore((state) => state.removeMessageZustand);

  useEffect(() => {
    if (!message) return;
    const segundos = SEGUNDOS_NA_TELA[messageType || "success"] ?? 8;
    const relogio = window.setTimeout(clearMessage, segundos * 1000);
    return () => window.clearTimeout(relogio);
  }, [message, messageType, clearMessage]);

  if (!message) return null;

  return (
    <AlfredoStyles.MessageBoxContainer
      messageType={
        messageType === "error" ||
        messageType === "warning" ||
        messageType === "success"
          ? messageType
          : "success"
      }
      role="status"
    >
      <span>{message}</span>
      <AlfredoStyles.CloseButton onClick={clearMessage} aria-label="Fechar">
        X
      </AlfredoStyles.CloseButton>
    </AlfredoStyles.MessageBoxContainer>
  );
};

export default MessageBox;
